import Repository from './Repository';

const resource = "/system";
export default {
    metrics() {
        return Repository.get(`${resource}/metrics/`);
    },
}